// Impact distribution by one formula
// I.e., A-F distribution of ALL company or security impact ratings for ONE formula
import * as c3 from 'c3';
import Chart from 'src/javascripts/components/Chart';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import ImpactDistChartTooltip from 'src/javascripts/components/charts/tooltips/ImpactDistChartTooltip';
import NoDataMessage from 'src/javascripts/components/alerts/NoDataMessage';

export default class ImpactDistByOneFormulaChart extends Chart {

  getData() {

    // Set a spinner to indicate chart loading
    Spinner('#' + this.el.attr('id'));

    // Get data for the specified formula
    let params = {};
    let accountUrl = $('body').attr('data-account-url');
    const formulaId = this.el.attr('data-api-formula-id');
    const letterGrades = this.el.attr('data-letter-grades');
    const recordType = this.el.attr('data-api-record-type') || 'companies';
    params['formula_id'] = formulaId;
    if (typeof letterGrades !== 'undefined') {params['letter_grades'] = letterGrades;}
    let url = '/' + accountUrl + '/' + recordType + '/ratings/distribution_by_formula?' + $.param(params);
    return $.getJSON(url);

  }

  render(data) {

    // Show no data message if none available
    // data[1] is the chart data; data[0] is dates array
    if ((data === null) || (data[1].length <= 1) || (typeof data[1] === 'undefined')) { 
      return NoDataMessage(this.el); 
    }

    // Set record type and formula id for on click url below
    const formulaId = this.el.attr('data-api-formula-id');
    const recordType = this.el.attr('data-api-record-type') || 'companies';

    // Render chart
    const chart = c3.generate({
      bindto: '#' + this.el.attr('id'),
      padding: {left: 0, bottom: -30},
      data: {
        type: 'bar',
        json: data,
        labels: true,
        keys: {
          x: 'name',
          value: [ 'value' ]
        },
        onclick: function (d, element) { 

          // Focus/de-focus, depending on current status
          if ( $(element).hasClass('selected') ) {

            $('.c3-bar').removeClass('lightest selected').addClass('opaque');
            let oTable = $('#top_rated_companies').DataTable();
            oTable.search('').draw();

          } else {

            $(element).removeClass('lightest').addClass('opaque selected');
            $('.c3-bar').not(element).removeClass('opaque selected').addClass('lightest');

            // On click of a bar, update table to show ratings for that letter (A, B, C, D or F)          
            let letterSearch;
            if (d.x === 0) {
              letterSearch = "A rating";
            } else if (d.x === 1) {
              letterSearch = "B rating";
            } else if (d.x === 2) {
              letterSearch = "C rating";
            } else if (d.x === 3) {
              letterSearch = "D rating";
            } else {
              letterSearch = "F rating";
            }

            // Search for the letter search (filtering handled in controller)
            let oTable = $('#top_rated_companies').DataTable();
            oTable.search(letterSearch).draw();

          }

        }
      },
      axis: {
        x: {type: 'category'},
        y: {
          show: false,
          padding: {top: 20}
        }
      },
      bar: {width: {ratio: 0.8}},
      legend: {hide: true},
      tooltip: {
        format: {},
        contents(d, defaultTitleFormat, defaultValueFormat, color) {
          return ImpactDistChartTooltip(this, d, defaultTitleFormat, defaultValueFormat, color);
        }
      },

      // Add color to bars
      onrendered() {
        $('#impact_dist_by_one_formula .c3-bar-0').addClass('bg-a-rating opaque');
        $('#impact_dist_by_one_formula .c3-bar-1').addClass('bg-b-rating opaque');
        $('#impact_dist_by_one_formula .c3-bar-2').addClass('bg-c-rating opaque');
        $('#impact_dist_by_one_formula .c3-bar-3').addClass('bg-d-rating opaque');
        $('#impact_dist_by_one_formula .c3-bar-4').addClass('bg-f-rating opaque');

        $('#impact_dist_by_one_formula .c3-axis-x g.tick text').off('click').on('click', function() {

          // Set index
          let text = $(this).text();

          // Set text
          if (text === '80-100') {
            text = 'A';
          } else if (text === '60-80') {
            text = 'B';
          } else if (text === '40-60') {
            text = 'C';
          } else if (text === '20-40') {
            text = 'D';
          } else if (text === '0-20') {
            text = 'F';
          }

          let c3bar = $('.c3-bar.bg-' + text.toLowerCase() + '-rating');

          // Focus/de-focus, depending on current status
          if ( c3bar.hasClass('selected') ) {

            $('.c3-bar').removeClass('lightest selected').addClass('opaque');
            let oTable = $('#top_rated_companies').DataTable();
            oTable.search('').draw();

          } else {

            c3bar.removeClass('lightest').addClass('opaque selected');
            $('.c3-bar').not(c3bar).removeClass('opaque selected').addClass('lightest');

            // Search for the letter search (filtering handled in controller)
            let oTable = $('#top_rated_companies').DataTable();
            oTable.search(text + ' rating').draw();

          }

        })

      }
    });

    // Set chart data to allow for destroying chart before Turbo cache
    // https://stackoverflow.com/questions/25765596/how-to-get-object-reference-from-selector-for-c3-js-charts
    $('#impact_dist_by_one_formula').data('c3-chart', chart);

    // Reflow on show of companies tab
    $('a[href="#companiesTab"]').on('shown.bs.tab', function (e) {
      chart.resize();
    });

    return chart;

  }
};